<template>
    <div class="edition" v-if="item" v-bind:class="{'edition-no-filetto' : num == 0}">
        <!-- @click="open" -->
        <p class="h1 artwork-title">{{item.post_title}}</p>
        <div class="edition-accordion" :id="item.post_name">
            <div class="h3 text-justify edition-abstract" v-if="item.post_content" v-html="item.post_content"></div>
            <div class="artworks">
                <Artwork v-for="(_item) in data" :key="_item.ID" :item="_item" :status="false" :color="item.acf.color" :player="false"></Artwork>
            </div>
            <div class="section-filetto">
                <div class="row">
                    <div class="col-sm-12" style="color: black !important">
                        <p class="h1 artwork-title" style="color: black; font-size: 4vw">
                            <router-link to="/echoes">ECHOES</router-link>
                        </p>
                        <div class="artworks">
                            <Artwork v-for="(_item) in contributors" :key="_item.ID" :item="_item" :status="false" :color="'#000'" :player="true"></Artwork>
                        </div>
                        <!--              <p class="h1 artwork-title" style="color: black; font-size: 4vw">
                            <router-link to="/echoes">LISTEN TO THE ECHOES</router-link>
                        </p> -->
                    </div>
                </div>
            </div>
            <div class="section-filetto">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="language">
                            <div class="col">
                                <div class="h4 text-justify" v-if="item.acf.main_content" v-html="item.acf.main_content"></div>
                            </div>
                            <div class="col">
                                <div class="h4 text-justify" v-if="item.acf.descrption_en" v-html="item.acf.descrption_en"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="logos-title h4" v-if="item.acf.logos_title" v-html="item.acf.logos_title"></div>
                        <div class="logos" v-if="item.acf.logos" style="text-align: center;">
                            <div class="logo-item" v-for="(logo, key) in item.acf.logos" :key="key">
                                <img :src="logo.url" :alt="logo.alt" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import qs from 'qs';
import Artwork from './Artwork';

export default {
    props: ['item', 'status', 'num'],
    name: 'programme',
    data() {
        return {
            data: null,
            contributors: null,
            pending: true,
            error: null,
            active: false,
            init: false
        }
    },
    components: {
        Artwork,
    },
    computed: {

    },
    mounted() {
        let self = this;
        this.load();

    },
    methods: {
        open() {
            this.active = !this.active;
        },
        load() {
            this.status = true;
            this.requestData();
            this.requestDataContributions();
        },
        async requestData() {
            this.pending = true
            try {
                const { data } = await axios.get(`${this.$store.state.api}/get_artworks`, {
                    params: { ids: this.item.acf.artwork.toString() },
                })
                this.data = data;
                this.error = false;
            } catch (e) {
                this.data = null;
                this.error = e;
            }
            this.pending = false;
        },
        async requestDataContributions() {
            try {
                const { data } = await axios.get(`${this.$store.state.api}/get_specific_contributions`, {
                    params: { ids: this.item.acf.contributors.toString() },
                })
                this.contributors = data;
                console.log(this.contributors);

                this.error = false;
            } catch (e) {
                this.data = null;
                this.error = e;
            }
        }
    },
    watch: {
        $route(to, from) {
            this.requestData();
            this.requestDataContributions();
        },
        active(n, o) {
            let self = this;
            let t = document.getElementById(this.item.post_name);
            let accordions = document.querySelectorAll('.edition-accordion');
            //chiudiamo tutto
            //dobbiamo fare qualche calcolo in piu perchè l'accordion non riesce a tenere di defaulr
            //l'altezza dei vari accordion interni
            //dunque dobbiamo continuare a cacolare l'altezza
            accordions.forEach(function(t) {
                // setTimeout(function() {
                //     t.style.height = t.scrollHeight + "px";
                // }, 0)
                // setTimeout(function() {
                //     t.style.height = 0;
                // }, 5)
                // self.active = false;
            })

            if (n) {
                if (t.offsetHeight == 0) {
                    // setTimeout(function() {
                    //     t.style.height = t.scrollHeight + "px";
                    // }, 1000)

                    // //Se non mettiamo questo auto non funziona l'altezza se apriamo gli accordion interni
                    // setTimeout(function() {
                    //     t.style.height = "auto";
                    // }, 2000)
                }
            }
        },
        data(n, o) {
            if (n != null && !this.init && this.num == 0) {
                this.open();
                this.init = true;
            }
        }
    }
}
</script>